var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSimulatorHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.00006 13.2495V27.9995C5.00006 28.2647 5.10542 28.5191 5.29295 28.7066C5.48049 28.8942 5.73484 28.9995 6.00006 28.9995H12.0001V20.4995C12.0001 20.1017 12.1581 19.7202 12.4394 19.4389C12.7207 19.1575 13.1022 18.9995 13.5001 18.9995H18.5001C18.8979 18.9995 19.2794 19.1575 19.5607 19.4389C19.842 19.7202 20.0001 20.1017 20.0001 20.4995V28.9995H26.0001C26.2653 28.9995 26.5196 28.8942 26.7072 28.7066C26.8947 28.5191 27.0001 28.2647 27.0001 27.9995V13.2495",
    stroke: "#666F7A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 16.0011L16.6806 3.25111C16.3681 2.92111 15.6375 2.91736 15.3194 3.25111L2 16.0011",
    stroke: "#666F7A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9999 11.1873V3.99976H21.9999V8.31226",
    stroke: "#666F7A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimulatorHome);
export default __webpack_public_path__ + "static/media/SimulatorHome.58b76489.svg";
export { ForwardRef as ReactComponent };